import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
  <site-head></site-head>

  <router-outlet></router-outlet>
  `,
  styles: [`
    `]
})
export class AppComponent {

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts